const BRAND = "oneAI";

/**
 * The browser tab's title: the brand first, then the page after a vertical bar
 * ("oneAI | Spaces"). Without a page name (the home page, or a chat whose name
 * has not loaded yet) it is the brand alone.
 */
export function pageTitle(page?: string | null): string {
	const name = page?.trim();
	return name ? `${BRAND} | ${name}` : BRAND;
}
